import {atoms, Box, withShade} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {CSSProperties} from 'react';

export const TableAddRowColumnButton = ({
  src,
  onClick,
  onMouseDownCapture,
  style,
}: {
  src?: React.ComponentType<React.SVGAttributes<SVGElement>>;
  onClick: (e: React.MouseEvent) => void;
  onMouseDownCapture?: (e: React.MouseEvent) => void;
  style: CSSProperties;
}) => (
  <Box
    {...withShade({
      duration: 'Instant',
      bgColors: {
        base: 'Primary Surface',
        active: 'Primary Surface - State 1',
      },
      style,
      className: atoms({
        backgroundColor: 'Background Subtle',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 'Medium',
      }),
    })}
    onMouseDown={(e: React.MouseEvent) => {
      // Prevent default to avoid taking focus from the editor
      e.preventDefault();
      if (onMouseDownCapture) {
        onMouseDownCapture(e);
      }
    }}
    onClick={onClick}
  >
    {src && <UIIcon src={src} size="small" />}
  </Box>
);
